export default __webpack_public_path__ + "static/media/ellipse_tr.1f16dedb.png";